import "./App.css";
import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useSearchParams, useNavigate } from "react-router-dom";
import { Header } from "./components/Header";
import Landing from "./pages/Landing";
import Leaderboard from "./pages/Leaderboard";
import BonusHuntPage from "./pages/BonusHuntPage";
import GuessingPage from "./pages/GuessingPage";
import AccountSettings from "./pages/AccountSettings";
import AdminPanel from "./pages/AdminPanel";
import OBSOverlay from "./pages/OBSOverlay";
import { checkAuth, saveToken } from "./services/api";

// Component to handle token from URL
function TokenHandler({ onTokenProcessed }) {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  useEffect(() => {
    const token = searchParams.get('token');
    if (token) {
      saveToken(token);
      navigate('/', { replace: true });
      onTokenProcessed();
    }
  }, [searchParams, navigate, onTokenProcessed]);
  
  return null;
}

function AppContent() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const doCheckAuth = async () => {
    try {
      const userData = await checkAuth();
      setUser(userData);
    } catch (error) {
      console.log('Not authenticated');
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    doCheckAuth();
  }, []);

  return (
    <>
      <TokenHandler onTokenProcessed={doCheckAuth} />
      <Routes>
        <Route path="/obs/bonus-hunt/:huntId" element={<OBSOverlay />} />
        <Route path="*" element={
          <>
            <Header user={user} onUserChange={setUser} />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/leaderboard" element={<Leaderboard />} />
              <Route path="/bonus-hunt" element={<BonusHuntPage user={user} />} />
              <Route path="/guessing" element={<GuessingPage user={user} />} />
              <Route path="/account-settings" element={<AccountSettings user={user} />} />
              <Route path="/admin" element={<AdminPanel user={user} />} />
            </Routes>
          </>
        } />
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </div>
  );
}

export default App;
